import React from 'react';
import { FaShip, FaOilCan, FaAtom, FaHamburger, FaSnowflake } from 'react-icons/fa';
import './Industries.css';

const industries = [
  {
    id: 1,
    icon: <FaShip />,
    title: '1. Судостроение и морская техника',
    description: 'Шкафы и корпуса из нержавеющей стали для морских судов, ледоколов, военных кораблей. Защита от коррозии, вибрации, электромагнитных помех. Соответствие требованиям РМРС.'
  },
  {
    id: 2,
    icon: <FaOilCan />,
    title: '2. Нефтегазовая отрасль',
    description: 'Взрывозащищённые шкафы и корпуса для терминалов, добычи и переработки. Работа при -50°С до +60°С. Соответствие ПБ 03-582-03.'
  },
  {
    id: 3,
    icon: <FaAtom />,
    title: '3. Атомная энергетика',
    description: 'Шкафы для АЭС, системы безопасности, АСУ ТП. Работа в условиях повышенных требований к надёжности. Опыт поставок на АЭС «Аккую», Смоленскую, Калининскую, Курскую.'
  },
  {
    id: 4,
    icon: <FaHamburger />,
    title: '4. Пищевая промышленность',
    description: 'Гигиенические корпуса из нержавеющей стали AISI 304 для открытых пищевых производств. Уклон крыши 30°, силиконовые уплотнители, стойкость к моющим средствам.'
  },
  {
    id: 5,
    icon: <FaSnowflake />,
    title: '5. Арктика и Крайний Север',
    description: 'Утеплённые термошкафы с обогревом и климат-контролем для работы при -50°С. Для КИПиА, автоматики, систем связи и телекоммуникаций.'
  }
];

const Industries = () => {
  return (
    <section id="industries" className="industries">
      <div className="container-custom">
        <div className="industries-grid">
          <div className="industries-image">
            <img src="/images/industries.webp" alt="Шкаф из нержавеющей стали для пищевой промышленности" />
          </div>
          
          <div className="industries-content">
            <h2 className="industries-title">Отрасли применения</h2>
            <p className="industries-subtitle">
              Работаем в ключевых отраслях промышленности
            </p>
            
            <div className="industries-list">
              {industries.map((industry) => (
                <div key={industry.id} className="industry-item">
                  <div className="industry-icon">
                    {industry.icon}
                  </div>
                  <div className="industry-text">
                    <h3 className="industry-title">{industry.title}</h3>
                    <p className="industry-description">{industry.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Industries;
